module.exports = __webpack_public_path__ + "img/headshot.060553dc.jpg";